import checkShortName from './checkShortName';
import fetchTeamData from './fetchTeamData';
import createTeam from './createTeam';
import updateTeamSettings from './updateTeamSettings';
import updateStory from './updateStory';
import pushToPage from './pushToPage';
import updateTeamName from './updateTeamName';
import fetchEventDetails from './fetchEventDetails';
import fetchFundraisingPages from './fetchFundraisingPages';
import linkFundraisingPage from './linkFundraisingPage';
import fetchFrpData from './fetchFrpData';
import createFundraisingPage from './createFundraisingPage';
import fetchMembersList from './fetchMembersList';
import updateShortName from './updateShortName';
import updateFundraisingData from './updateFundraisingData';
import activatePage from './activatePage';
import checkFrpShortName from './checkFrpShortName';
import submitTeamData from './submitTeamData';
import updateMembershipPolicy from './updateMembershipPolicy';
import unlinkMember from './unlinkMember';
import linkSelectedFundraisingPage from './linkSelectedFundraisingPage';
import deleteTeam from './deleteTeam';
import fetchGDPRConsents from './fetchGDPRConsents';
import updateGDPRConsents from './updateGDPRConsents';
import updateTeamMembersTarget from './updateTeamMembersTarget';
import logInfo from './logInfo';
import fetchLockData from './fetchLockData';
import createConsumerEvent from './createConsumerEvent';
import fetchAppData from './fetchAppData';
import fetchCharityData from './fetchCharityData';
import updateTeamLocks from './updateTeamLocks';

const apiThunk = {
  checkShortName,
  fetchTeamData,
  createTeam,
  updateTeamSettings,
  updateStory,
  updateTeamName,
  fetchEventDetails,
  fetchFundraisingPages,
  linkFundraisingPage,
  fetchFrpData,
  createFundraisingPage,
  fetchMembersList,
  updateShortName,
  updateFundraisingData,
  activatePage,
  checkFrpShortName,
  deleteTeam,
  submitTeamData,
  updateMembershipPolicy,
  unlinkMember,
  linkSelectedFundraisingPage,
  fetchGDPRConsents,
  updateGDPRConsents,
  updateTeamMembersTarget,
  logInfo,
  fetchLockData,
  createConsumerEvent,
  fetchAppData,
  fetchCharityData,
  updateTeamLocks,
};

const appThunk = {
  pushToPage,
};

export { apiThunk, appThunk };
